<form
  [formGroup]="cellPhoneForm"
  *ngIf="componentClasses"
  [ngClass]="componentClasses['form']"
>
  <div [ngClass]="componentClasses['inputdiv']">
    <label for="CellPhoneNumber">Cell Phone Number</label>
    <img
      class="info-icon"
      src="./assets/icons/info.svg"
      alt=""
      pTooltip="{{ CellPhoneInfo }}"
      tooltipZIndex="10000"
      *ngIf="isAllowEdit || isShowOnDisabledState"
    />
    <input
      id="CellPhoneNumber"
      type="text"
      [ngClass]="componentClasses['input']"
      placeholder="xxx-xxx-xxxx"
      formControlName="cellPhoneNumber"
      [maxlength]="12"
      phoneNumber
      faxNumber
      cellPhoneNumber
      preventSpace
      autocompleteOff
      preventSpace
    />
    <div class="error-container">
      <span
        class="error"
        *ngIf="
          cellPhoneForm.get('cellPhoneNumber')?.dirty &&
          cellPhoneForm.get('cellPhoneNumber')?.value.length > 0 &&
          !isCellPhoneNumberValid
        "
        >Cell Phone Number should be minimum 10 digits.</span
      >
      <span
        class="error"
        *ngIf="
          cellPhoneForm.get('cellPhoneNumber')?.dirty &&
          isCellPhoneNumberValid &&
          CheckInValidCellPhoneNumber()
        "
        >Invalid Cell Phone Number or Format.</span
      >
    </div>
    <div *ngIf="isAllowEdit || isShowOnDisabledState">
      <button
        *ngIf="!isCellPhoneNumberValid"
        type="button"
        class="button button-light cell-invalid"
      >
        <img src="./assets/icons/mobile_friendly.svg" alt="" />
        Verify Cell Phone Number
      </button>
      <button
        *ngIf="
          isCellPhoneNumberValid &&
          !isCellVerified &&
          !CheckInValidCellPhoneNumber()
        "
        type="button"
        class="button button-light cell-valid"
        (click)="OpenOTPModal()"
      >
        <img src="./assets/icons/mobile_friendly_blue.svg" alt="" />
        Verify Cell Phone Number
      </button>

      <button
        *ngIf="isCellVerified"
        type="button"
        class="button button-light cell-verified"
      >
        <img src="./assets/icons/check_circle.svg" alt="" />
        Verified Cell Phone Number
      </button>
    </div>
  </div>
  <div [ngClass]="componentClasses['radio']">
    <div class="n-input-group">
      <label for="CellPhoneNumber">Cell Phone/SMS/Text Communication</label>

      <span
        [pTooltip]="tooltiptemplate"
        tooltipZIndex="10000"
        *ngIf="isAllowEdit || isShowOnDisabledState"
      >
        <img class="info-icon" src="./assets/icons/info.svg" alt="" />
      </span>
      <ng-template #tooltiptemplate>
        <div [innerHTML]="OptInOptOutInfo"></div>
      </ng-template>
      <div class="d-flex mt5">
        <label class="radiobtn-container">
          <input
            type="radio"
            formControlName="isOptInForCommunication"
            [value]="true"
            id="optIn"
          />
          <span
            [ngClass]="
              cellPhoneForm.get('isOptInForCommunication')?.disabled
                ? 'radiobtncheckmark radio-disabled'
                : 'radiobtncheckmark'
            "
          ></span>
          <span class="radiotxt fw-400">Opt In</span>
        </label>
        <label class="radiobtn-container">
          <input
            type="radio"
            formControlName="isOptInForCommunication"
            [value]="false"
            id="optout"
          />
          <span
            [ngClass]="
              cellPhoneForm.get('isOptInForCommunication')?.disabled
                ? 'radiobtncheckmark radio-disabled'
                : 'radiobtncheckmark'
            "
          ></span>
          <span class="radiotxt fw-400">Opt Out</span>
        </label>
      </div>
    </div>
  </div>
</form>

<phone-verification-modal
  *ngIf="isCellPhoneNumberValid"
  [phoneNumber]="cellPhoneNumber"
  [isModalOpen]="isShowOTPModal"
  (close)="HandleCloseModal()"
  (phoneHash)="handlePhoneHash($event)"
></phone-verification-modal>
